import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationIcon, XIcon } from "@heroicons/react/outline";
import { CIcon } from "@coreui/icons-react";
import { cifAU } from "@coreui/icons";
import { createMuiTheme, ThemeProvider } from "@material-ui/core";
import AudioPlayer from "material-ui-audio-player";
import axios from "axios";
import { ToastContainer, toast } from "react-toast";
import { withTranslation } from "react-i18next";
import { Listbox } from "@headlessui/react";
import { CheckIcon, SelectorIcon } from "@heroicons/react/solid";

const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");
const BackendURL = window.BackendURLCmk;
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
function Modalchoix(props) {
  const { t, tReady } = props;
  const people = [
    { id: 1, name: "1 " + t("sonnerie") },
    { id: 2, name: "2 " + t("sonnerie") + "s" },
    { id: 3, name: "3 " + t("sonnerie") + "s" },
    { id: 4, name: "4 " + t("sonnerie") + "s" },
    { id: 5, name: "5 " + t("sonnerie") + "s" },
    { id: 6, name: "6 " + t("sonnerie") + "s" },
    { id: 7, name: "7 " + t("sonnerie") + "s" },
  ];
  const [selected, setSelected] = useState(people[0]);
  const [selectedcollegue, setSelectedcollegue] = useState("");

  const [allprofil, setallprofil] = useState([]);
  const [open, setOpen] = useState(false);
  const [checked1, setChecked1] = React.useState(false);
  const [checked2, setChecked2] = React.useState(false);
  const [checked3, setChecked3] = React.useState(false);

  function getallprofil() {
    var lien = window.location.href;
    const var2 = lien.split("/");
    //console.log("kien ici", var2[2]);
    var var4 = var2[2].split(":");
    // console.log("kien ici", var4[0]);
    var config = {
      headers: {
        Authorization: token,
      },
    };
    const res = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/ColleguesIPBXV3APIPROFIL
?compte=${compte}&poste=${poste}`,
        config
      )
      .then((res) => {
        const data = res.data.collegues;
        setallprofil(data);
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  }
  const handleChange1 = () => {
    setChecked1(true);
    setChecked2(false);
    setChecked3(false);
    getallprofil();
  };
  const handleChange2 = () => {
    setChecked1(false);
    setChecked2(true);
    setChecked3(false);
  };
  const handleChange3 = () => {
    setChecked1(false);
    setChecked2(false);
    setChecked3(true);
  };

  const [inputValuenum, setInputValuenum] = useState("");
  //const [inputValuesonnerie, setInputValuesonnerie] = useState("");
  function clearInput() {
    setInputValuenum("");
    // setInputValuesonnerie("");
    setChecked1(false);
    setChecked2(false);
    setChecked3(false);
  }

  function handleInputChangenum(event) {
    setInputValuenum(event.target.value);
  }
  function handleInputChangesonnerie(event) {
    //setInputValuesonnerie(event.target.value);
  }

  function handleSubmit(e) {
    e.preventDefault();
    var lien = window.location.href;
    //console.log(lien);
    const var2 = lien.split("/");
    //console.log("kien ici", var2[2]);
    var var4 = var2[2].split(":");
    // console.log("kien ici", var4[0]);
    var config = {
      headers: {
        Authorization: token,
      },
    };
    var destination = "";
    if (checked1 == true) {
      destination = "1";
    } else if (checked2 == true) {
      destination = "10";
    } else if (checked3 == true) {
      destination = "2";
    }
    var sonnerie = selected.id * 5;
    var poste_num;
    if (checked1 == true) {
      poste_num = selectedcollegue.poste;
    } else if (checked2 == true) {
      poste_num = inputValuenum;
    } else if (checked3 == true) {
      poste_num = poste;
    }
    axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/RenvoiInjoignabiliterInterneIPBXV3API?compte=${compte}&poste=${poste}&nbr_sonnerie=${sonnerie}&action_appel_interne=${destination}&destination_appel_interne=${poste_num}`,
        config
      )
      .then((res) => {
        props.toggle();
        // this.getAllcontact();
        // this.setState({ redirectToReferrer: true });
        //props.toggle();
        clearInput();
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  }

  return (
    <Transition.Root show={props.showModal} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed z-10 inset-0 overflow-y-auto"
        open={open}
        onClose={props.handleClose}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className=" dark:bg-gray-800 dark:text-white inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
              <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                <ToastContainer delay={3000} position={"top-right"} />
                <button
                  type="button"
                  className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                  onClick={props.handleClose}
                >
                  <span className="sr-only">Close</span>
                  <XIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
              <div className="sm:flex sm:items-start">
                <div className="dark:text-white dark:bg-gray-400 mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                  <svg
                    class="h-6 w-6"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="random"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    data-fa-i2svg=""
                  >
                    <path
                      fill="currentColor"
                      d="M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
                    ></path>
                  </svg>
                </div>
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <Dialog.Title
                    as="h3"
                    className="dark:text-white text-lg leading-6 font-medium text-gray-900"
                  >
                    {t("transfer.interne.title")}
                  </Dialog.Title>
                </div>
              </div>
              <fieldset className="mt-8 flex">
                <div className="relative flex items-start mr-4">
                  <div className="flex items-center h-5">
                    <input
                      id="comments"
                      aria-describedby="comments-description"
                      name="myGroupName"
                      type="radio"
                      value={checked1}
                      onChange={handleChange1}
                      className="focus:ring-green-500 h-4 w-4 text-green-600 border-gray-300 rounded"
                    />
                  </div>
                  <div className="ml-1 text-sm">
                    <label
                      htmlFor="comments"
                      className="dark:text-gray-300 font-medium text-gray-700"
                    >
                      {t("extension.interne")}{" "}
                    </label>
                  </div>
                </div>
                <div className="relative flex items-start mr-4 ">
                  <div className="flex items-center h-5">
                    <input
                      id="candidates"
                      aria-describedby="candidates-description"
                      name="myGroupName"
                      type="radio"
                      value={checked2}
                      onChange={handleChange2}
                      className="focus:ring-green-500 h-4 w-4 text-green-600 border-gray-300 rounded"
                    />
                  </div>
                  <div className="ml-1 text-sm">
                    <label
                      htmlFor="candidates"
                      className="dark:text-gray-300 font-medium text-gray-700"
                    >
                      {t("phonenumber")}
                    </label>
                  </div>
                </div>
                <div className="relative flex items-start">
                  <div className="flex items-center h-5">
                    <input
                      id="offers"
                      aria-describedby="offers-description"
                      name="myGroupName"
                      type="radio"
                      value={checked3}
                      onChange={handleChange3}
                      className="focus:ring-green-500 h-4 w-4 text-green-600 border-gray-300 rounded"
                    />
                  </div>
                  <div className="ml-1 text-sm">
                    <label
                      htmlFor="offers"
                      className="dark:text-gray-300 font-medium text-gray-700"
                    >
                      {t("boitevocalemini")}
                    </label>
                  </div>
                </div>
              </fieldset>
              <div className="">
                <div className="flex mt-6 mb-4">
                  <div className="mr-4 mt-1">{t("renvoi.chaq.appel")}</div>
                  <Listbox
                    value={selected}
                    onChange={setSelected}
                    className="relative inline-block"
                  >
                    {({ open }) => (
                      <>
                        <div className="mt-1 relative">
                          <Listbox.Button className="relative w-40 bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 sm:text-sm">
                            <span className="block truncate font-medium text-gray-700">
                              {selected.name}
                            </span>
                            <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                              <SelectorIcon
                                className="h-5 w-5 text-gray-400"
                                aria-hidden="true"
                              />
                            </span>
                          </Listbox.Button>

                          <Transition
                            show={open}
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                          >
                            <Listbox.Options
                              className="absolute z-10 mt-1 h-24 w-40 bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
                              //  style={{ zIndex: "9999" }}
                            >
                              {people.map((person) => (
                                <Listbox.Option
                                  key={person.id}
                                  className={({ active }) =>
                                    classNames(
                                      active
                                        ? "text-white bg-green-600"
                                        : "text-gray-900",
                                      "cursor-default select-none relative py-2 pl-8 pr-4"
                                    )
                                  }
                                  value={person}
                                >
                                  {({ selected, active }) => (
                                    <>
                                      <span
                                        className={classNames(
                                          selected
                                            ? "font-semibold"
                                            : "font-normal",
                                          "block truncate"
                                        )}
                                      >
                                        {person.name}
                                      </span>

                                      {selected ? (
                                        <span
                                          className={classNames(
                                            active
                                              ? "text-white"
                                              : "text-green-600",
                                            "absolute inset-y-0 left-0 flex items-center pl-1.5"
                                          )}
                                        >
                                          <CheckIcon
                                            className="h-5 w-5"
                                            aria-hidden="true"
                                          />
                                        </span>
                                      ) : null}
                                    </>
                                  )}
                                </Listbox.Option>
                              ))}
                            </Listbox.Options>
                          </Transition>
                        </div>
                      </>
                    )}
                  </Listbox>
                </div>
                {/* <div className="flex"> */}{" "}
                {checked1 ? (
                  <div className="flex">
                    <span className="mt-2 mr-4">{t("vers")}</span>
                    <Listbox
                      value={selectedcollegue}
                      onChange={setSelectedcollegue}
                      className="relative inline-block"
                    >
                      {({ open }) => (
                        <>
                          <div className="mt-1 relative">
                            <Listbox.Button className="relative w-48 bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-1 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 sm:text-sm">
                              <span className="flex items-center">
                                {selectedcollegue.photo_poste_interne ? (
                                  <img
                                    src={
                                      selectedcollegue.lien_photo_poste_interne
                                    }
                                    alt=""
                                    className="flex-shrink-0 h-8 w-8 rounded-full"
                                  />
                                ) : (
                                  <span className="flex-shrink-0 inline-block overflow-hidden h-8 w-8 rounded-full  bg-gray-200 dark:bg-gray-700">
                                    <svg
                                      className="h-8 w-8 text-gray-400 dark:text-gray-400"
                                      fill="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path>
                                    </svg>
                                  </span>
                                )}
                                <span className="dark:text-gray-900 ml-3 block truncate">
                                  {selectedcollegue.nom}
                                </span>
                              </span>
                              <span className="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                <SelectorIcon
                                  className="h-5 w-5 text-gray-400"
                                  aria-hidden="true"
                                />
                              </span>
                            </Listbox.Button>

                            <Transition
                              show={open}
                              as={Fragment}
                              leave="transition ease-in duration-100"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                            >
                              <Listbox.Options className="h-28 absolute z-10 mt-1 w-48 bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                                {allprofil.map((person) => (
                                  <Listbox.Option
                                    key={person.nom}
                                    className={({ active }) =>
                                      classNames(
                                        active
                                          ? "text-white bg-green-600"
                                          : "text-gray-900",
                                        "cursor-default select-none relative py-2 pl-3 pr-9"
                                      )
                                    }
                                    value={person}
                                  >
                                    {({ selectedcollegue, active }) => (
                                      <>
                                        <div className="flex items-center">
                                          {person.photo_poste_interne ? (
                                            <img
                                              src={
                                                person.lien_photo_poste_interne
                                              }
                                              alt=""
                                              className="flex-shrink-0 h-8 w-8 rounded-full"
                                            />
                                          ) : (
                                            <span className="flex-shrink-0 inline-block overflow-hidden h-8 w-8 rounded-full  bg-gray-200 dark:bg-gray-700">
                                              <svg
                                                className="h-8 w-8 text-gray-400 dark:text-gray-400"
                                                fill="currentColor"
                                                viewBox="0 0 24 24"
                                              >
                                                <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path>
                                              </svg>
                                            </span>
                                          )}
                                          <span
                                            className={classNames(
                                              selectedcollegue
                                                ? "font-semibold"
                                                : "font-normal",
                                              "ml-3 block truncate"
                                            )}
                                          >
                                            {person.nom}
                                          </span>
                                        </div>

                                        {selectedcollegue ? (
                                          <span
                                            className={classNames(
                                              active
                                                ? "text-white"
                                                : "text-green-600",
                                              "absolute inset-y-0 right-0 flex items-center pr-4"
                                            )}
                                          >
                                            <CheckIcon
                                              className="h-5 w-5"
                                              aria-hidden="true"
                                            />
                                          </span>
                                        ) : null}
                                      </>
                                    )}
                                  </Listbox.Option>
                                ))}
                              </Listbox.Options>
                            </Transition>
                          </div>
                        </>
                      )}
                    </Listbox>
                  </div>
                ) : (
                  <>
                    {checked2 ? (
                      <div className="flex">
                        <span className="mt-2 mr-4">{t("vers")}</span>
                        <input
                          type="text"
                          value={inputValuenum}
                          onChange={handleInputChangenum}
                          className="dark:text-gray-900 mt-1 relative w-40  bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 sm:text-sm"
                        />
                      </div>
                    ) : (
                      <>
                        {checked3 ? (
                          <div className="flex">
                            <span className="mt-2 mr-4">
                              {t("vers")} votre boite vocale
                            </span>
                          </div>
                        ) : (
                          <div className="flex">
                            <span className="mt-2 mr-4">
                              {t("vers")} ...............{" "}
                            </span>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
              <form onSubmit={handleSubmit}>
                <div className="px-6 py-4 mt-8 text-right sm:px-6">
                  <input
                    onClick={props.handleClose}
                    value={t("Confirmer")}
                    type="submit"
                    className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                  />
                </div>
              </form>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
export default withTranslation("common")(Modalchoix);
